<template>
  <div v-if="redirect.status" class="modal__overlay">
    <div class="modal">
      <div class="modal__message">{{ redirect.message }}</div>
      <v-btn block color="primary" :to="redirect.url" @click="clearRedirect">Продолжить</v-btn>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.modal {
  background: #f5f5f6;
  border-radius: 2px;
  padding: 32px;
  max-width: 320px;

  &__message {
    margin-bottom: 24px;
  }

  &__overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(37, 62, 119, 0.32);
    z-index: 100000;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>

<script>
import { mapGetters, mapMutations } from "vuex";

export default {
  computed: {
    ...mapGetters("common", ["redirect"]),
  },
  methods: {
    ...mapMutations("common", ["clearRedirect"]),
  },
};
</script>
